import * as React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import MyDebtsQuery from '../../components/queries/MyDebtsQuery'
import MyLoansQuery from '../../components/queries/MyLoansQuery'
import MyClosedLoansQuery from '../../components/queries/MyClosedLoansQuery'
import Loading from '../../components/Loading'
import Headline from '../../components/Headline'
import HeaderContainer from '../../components/HeaderContainer'

import UserDebtsTable from './UserDebtsTable'
import UserLoansTable from './UserLoansTable'
import UserClosedLoansTable from './UserClosedLoansTable'

const DashboardUser: React.SFC = () => (
  <div>
    <HeaderContainer>
      <div>
        <Headline>Moje dluhy</Headline>
        <p>To co jsem si já od někoho půjčil</p>
      </div>
      <ButtonToolbar>
        <LinkContainer to="/loans/create">
          <Button id="create-loan">Vytvořit půjčku</Button>
        </LinkContainer>
      </ButtonToolbar>
    </HeaderContainer>
    <MyDebtsQuery>
      {({ loading, data, error }) => {
        if (loading) {
          return <Loading />
        }

        if (data == null || error != null) {
          return <div>Error</div>
        }

        return (
          <div>
            <UserDebtsTable debts={data.user.debts} />
          </div>
        )
      }}
    </MyDebtsQuery>
    <HeaderContainer>
      <div>
        <Headline>Moje půjčky</Headline>
        <p>To co jsem já půjčil někomu</p>
      </div>
    </HeaderContainer>
    <MyLoansQuery>
      {({ loading, data, error }) => {
        if (loading) {
          return <Loading />
        }

        if (data == null || error != null) {
          return <div>Error</div>
        }

        return <UserLoansTable loans={data.user.loans} />
      }}
    </MyLoansQuery>
    <HeaderContainer>
      <Headline>Historie půjček</Headline>
    </HeaderContainer>
    <MyClosedLoansQuery>
      {({ loading, data, error }) => {
        if (loading) {
          return <Loading />
        }

        if (data == null || error != null) {
          return <div>Error</div>
        }

        return <UserClosedLoansTable loans={data.user.closedLoans} />
      }}
    </MyClosedLoansQuery>
  </div>
)

export default DashboardUser



// WEBPACK FOOTER //
// ./src/screens/dashboard/DashboardUser.tsx